module.exports = __webpack_public_path__ + "static/media/rc-clinical-trials-icon.2bf431dc.svg";